<template>
  <div class="freight_query">
    <!--运费查询头部-->
    <div class="freight_query_top">
      <div>
        <el-select v-model="selectChannelValue" placeholder="渠道">
          <el-option
            v-for="item in channelList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model="selectCourierCompany" placeholder="快递公司">
          <el-option
            v-for="item in courierCompanyList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model="selectRegion" placeholder="地区">
          <el-option
            v-for="item in regionList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model="selectProvince" placeholder="省份">
          <el-option
            v-for="item in provincesList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>

      <button class="btn_normal ml10" @click="queryData()">查询</button>
      <button class="btn_normal ml10" @click="exportAgentStoreroomLogisticPostageData()">导出运费</button>
    </div>

    <!--运费查询列表-->
    <div class="freight_query_msg">
      <table class="table">
        <thead>
        <tr>
          <th>快递公司</th>
          <th>渠道</th>
          <th>省份</th>
          <th>首重（kg）</th>
          <th>续重（kg）</th>
          <th>基本运费</th>
          <th>续费</th>
        </tr>
        </thead>
        <tbody v-if="list.length" v-for="(item, index) in list" :key="index">
        <tr>
          <td>{{item.LogisticName}}</td>
          <td>{{item.StoreroomName}}</td>
          <td>{{item.ProvinceName}}</td>
          <td>{{item.FirstWeight}}</td>
          <td>{{item.ContinueWeight}}</td>
          <td>{{item.FirstMoney}}</td>
          <td>{{item.ContinueMoney}}</td>
        </tr>
        </tbody>
        <tbody v-if="!list.length">
        <tr>
          <td colspan="7">{{listErr}}</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div class="text_right mt20">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script type="es6">
  import LoadingDialog from '../../public-component/loading-dialog';
  import MsgDialog from '../../public-component/msg-dialog';

  export default {
    name: 'freight-query',
    components: {LoadingDialog, MsgDialog},
    data() {
      return {
        list: [], // 运费列表
        listErr: '暂时没有相关信息', // 列表查询错误信息
        channelList: [], // 渠道下拉列表
        selectChannelValue: '', // 选择的渠道列表
        courierCompanyList: [], // 快递公司下拉
        selectCourierCompany: '', // 选择的快递公司
        regionList: [], // 地区下拉
        selectRegion: null, // 选择的地区
        provincesList: [], // 省份下拉
        selectProvince: '', // 选择的省份
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载框类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 10 // 总条数
      }
    },
    methods: {
      // 获取渠道下拉框信息
      getAllStoreroomsList() {
        this.$axios.get(this.Global.getAllStoreroomsList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.channelList = res.data.resData;
            this.channelList.splice(0, 0, {id: '', text: '所有渠道'});
            this.selectChannelValue = '';
          } else {
            this.channelList = [];
            this.selectChannelValue = res.data.errorMsg;
          }
        });
      },

      // 获取地区下拉框
      getAllRegionList() {
        this.$axios.get(this.Global.getAllRegionList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.regionList = res.data.resData;
            this.regionList.splice(0, 0, {id: '', text: '所有地区'});
            this.selectRegion = '';
          } else {
            this.regionList = [];
            this.selectRegion = res.data.errorMsg;
          }
        });
      },

      // 获取快递公司下拉框
      getAllLogisticList() {
        this.$axios.get(this.Global.getAllLogisticList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.courierCompanyList = res.data.resData;
            this.courierCompanyList.splice(0, 0, {id: '', text: '所有快递'});
            this.selectCourierCompany = '';
          } else {
            this.courierCompanyList = [];
            this.selectCourierCompany = res.data.errorMsg;
          }
        });
      },

      // 获取省份下拉框
      getAllProvinceList() {
        this.$axios.get(this.Global.getAllProvinceList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.provincesList = res.data.resData;
            this.provincesList.splice(0, 0, {id: '', text: '所有省份'});
            this.selectProvince = '';
          } else {
            this.provincesList = [];
            this.selectProvince = res.data.errorMsg;
          }
        });
      },

      // 查询数据
      queryData() {
        this.currentPage = 1;
        this.loadAllAgentStoreroomLogisticPostagePageData();
      },

      // 运费查询分页数据
      loadAllAgentStoreroomLogisticPostagePageData() {
        this.isLoading = true;
        const params = {
          storeroomId: this.selectChannelValue,
          RegionId: this.selectRegion,
          logisticId: this.selectCourierCompany,
          provinceId: this.selectProvince,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.loadAllAgentStoreroomLogisticPostagePageData, params).then((res) => {
          const self = this;
          let timer;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (!res.data.errorMsg.length) {
              self.list = res.data.resData.DataList;
              self.total = res.data.resData.TotalCounts;
            } else {
              self.list = [];
              self.listErr = res.data.errorMsg;
            }
          }, 500);
        });
      },

      // 运费导出Excel
      exportAgentStoreroomLogisticPostageData() {
        const params = {
          storeroomId: this.selectChannelValue,
          RegionId: this.selectRegion,
          logisticId: this.selectCourierCompany,
          provinceId: this.selectProvince,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.exportAgentStoreroomLogisticPostageData, params).then((res) => {
          if (!res.data.errorMsg.length) {
            window.open(res.data.resData, '_blank');
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.loadAllAgentStoreroomLogisticPostagePageData();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.loadAllAgentStoreroomLogisticPostagePageData();
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      this.getAllStoreroomsList();
      this.getAllRegionList();
      this.getAllLogisticList();
      this.getAllProvinceList();
      this.loadAllAgentStoreroomLogisticPostagePageData();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .freight_query {

    .freight_query_top {
      margin: 10px;
      display: flex;

      & > div {
        display: inline-block;
        width: 17%;
        margin-right: 1%;
      }
    }

    .freight_query_msg {
      padding: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/freight-query.vue